[ {
    "display": "true",
    "ui_columnname": "Start Time",
    "db_columnname": "startTime",
    "datatype": "String",
    "mappingkey": "startTime",
    "dropdown": "NO",
    "isdefault": "false",
    "disabled": "false",
    "value": "",
    "dropdowntype": "singleselect",
    "dropdownvalue": ""
    },{
    "display": "true",
    "ui_columnname": "Finish Time",
    "db_columnname": "finishTime",
    "datatype": "String",
    "mappingkey": "finishTime",
    "dropdown": "NO",
    "isdefault": "false",
    "disabled": "false",
    "value": "",
    "dropdowntype": "singleselect",
    "dropdownvalue": ""
    }, {
    "display": "true",
    "ui_columnname": "Description",
    "db_columnname": "processRemark",
    "datatype": "String",
    "mappingkey": "processRemark",
    "dropdown": "NO",
    "isdefault": "false",
    "disabled": "false",
    "value": "",
    "dropdowntype": "singleselect",
    "dropdownvalue": ""
    }, {
    "display": "true",
    "ui_columnname": "Report Date",
    "db_columnname": "reportDate",
    "datatype": "String",
    "mappingkey": "reportDate",
    "dropdown": "NO",
    "isdefault": "false",
    "disabled": "false",
    "value": "",
    "dropdowntype": "singleselect",
    "dropdownvalue": ""
    }, {
    "display": "true",
    "ui_columnname": "File Name",
    "db_columnname": "fileName",
    "datatype": "String",
    "mappingkey": "fileName",
    "dropdown": "NO",
    "isdefault": "false",
    "disabled": "false",
    "value": "",
    "dropdowntype": "singleselect",
    "dropdownvalue": ""
    }, {
    "display": "true",
    "ui_columnname": "Total Records",
    "db_columnname": "fileTotalRecords",
    "datatype": "String",
    "mappingkey": "fileTotalRecords",
    "dropdown": "NO",
    "isdefault": "false",
    "disabled": "false",
    "value": "",
    "dropdowntype": "singleselect",
    "dropdownvalue": ""
    },{
    "display": "true",
    "ui_columnname": "Success Flag",
    "db_columnname": "successFlag",
    "datatype": "String",
    "mappingkey": "successFlag",
    "dropdown": "NO",
    "isdefault": "false",
    "disabled": "false",
    "value": "",
    "dropdowntype": "singleselect",
    "dropdownvalue": ""
    },{
    "display": "true",
    "ui_columnname": "Process Type",
    "db_columnname": "processType",
    "datatype": "String",
    "mappingkey": "processType",
    "dropdown": "NO",
    "isdefault": "false",
    "disabled": "false",
    "value": "",
    "dropdowntype": "singleselect",
    "dropdownvalue": ""
    },{
    "display": "true",
    "ui_columnname": "Reporting Quarter",
    "db_columnname": "reportingQuarter",
    "datatype": "String",
    "mappingkey": "reportingQuarter",
    "dropdown": "NO",
    "isdefault": "false",
    "disabled": "false",
    "value": "",
    "dropdowntype": "singleselect",
    "dropdownvalue": ""
    },{
    "display": "true",
    "ui_columnname": "Reporting Year",
    "db_columnname": "reportingYear",
    "datatype": "String",
    "mappingkey": "reportingYear",
    "dropdown": "NO",
    "isdefault": "false",
    "disabled": "false",
    "value": "",
    "dropdowntype": "singleselect",
    "dropdownvalue": ""
    },{
    "display": "true",
    "ui_columnname": "Reporting Start Date",
    "db_columnname": "reportingStartDate",
    "datatype": "String",
    "mappingkey": "reportingStartDate",
    "dropdown": "NO",
    "isdefault": "false",
    "disabled": "false",
    "value": "",
    "dropdowntype": "singleselect",
    "dropdownvalue": ""
    }, {
    "display": "true",
    "ui_columnname": "Reporting End Date",
    "db_columnname": "reportingEndDate",
    "datatype": "String",
    "mappingkey": "reportingEndDate",
    "dropdown": "NO",
    "isdefault": "false",
    "disabled": "false",
    "value": "",
    "dropdowntype": "singleselect",
    "dropdownvalue": ""
    }, {
    "display": "true",
    "ui_columnname": "Error Level",
    "db_columnname": "errorLevel",
    "datatype": "String",
    "mappingkey": "errorLevel",
    "dropdown": "NO",
    "isdefault": "false",
    "disabled": "false",
    "value": "",
    "dropdowntype": "singleselect",
    "dropdownvalue": ""
    },
{
    "display": "true",
    "ui_columnname": "Error Details",
    "db_columnname": "errorDetails",
    "datatype": "String",
    "mappingkey": "errorDetails",
    "dropdown": "NO",
    "isdefault": "false",
    "disabled": "false",
    "value": "",
    "dropdowntype": "singleselect",
    "dropdownvalue": ""
    },{
    "display": "true",
    "ui_columnname": "Status",
    "db_columnname": "status",
    "datatype": "String",
    "mappingkey": "status",
    "dropdown": "NO",
    "isdefault": "false",
    "disabled": "false",
    "value": "",
    "dropdowntype": "singleselect",
    "dropdownvalue": ""
    },{
    "display": "true",
    "ui_columnname": "Duration",
    "db_columnname": "duration",
    "datatype": "String",
    "mappingkey": "duration",
    "dropdown": "NO",
    "isdefault": "false",
    "disabled": "false",
    "value": "",
    "dropdowntype": "singleselect",
    "dropdownvalue": ""
    }]